import { render } from "./ubuntu_body_banner7.vue?vue&type=template&id=66f9be8d&scoped=true"
import script from "./ubuntu_body_banner7.vue?vue&type=script&lang=js"
export * from "./ubuntu_body_banner7.vue?vue&type=script&lang=js"

import "./ubuntu_body_banner7.vue?vue&type=style&index=0&id=66f9be8d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f9be8d"]])

export default __exports__